import { Center } from "@/components/ui/center";
import { View } from "@/components/ui/view";
import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Box } from "@/components/ui/box";
import { Button } from "@/components/ui/button";
import i18n from 'i18n-js';
import React from 'react';
import { useSelector } from 'react-redux';
import { switchScreen } from '@/hooks/navigate';
import ImageSynced from '@/components/media/ImageSynced';
import { isMedia, isVideo } from '@/components/media/MediaSelector';
import { IconM } from '@/components/media/IconsV2';

export default function SearchListElement({ navigation, task, onDelete, icon, changed }) {

    const imgLoad = useSelector((state) => state.images.load)

    const onLayoutItem = event => {
        console.log(event.nativeEvent.layout)
    };

    const onLongPress = event => {
        if (onDelete) {
            onDelete(task.id)
        }
    };

    return (
        <Button disabled={!navigation} onLongPress={onLongPress} onPress={() => { if (navigation) switchScreen(navigation, 'ShowWorkflow2', { taskid: task.id, isLoading: false }) }} className="w-[47%] mb-2 border-secondary-300 border rounded-[10px] bg-secondary-50 h-[225px] active:bg-primary-300">
            <VStack className="px-1 pt-2">
                {isMedia(task.media[0]) ?
                    <IconM className="text-9xl text-primary-900" name={isVideo(task.media[0]) ? 'videocam' : 'audiotrack'} />
                    :
                    <Center className="w-[140px] h-[140px]">
                        <ImageSynced key={task.media[0] + '_' + imgLoad[task.media[0]]?.duration} uri={task.media[0]} resizeMode='cover' className="w-full h-full" />
                        <View className={` ${changed ? "w-[2px]" : "w-[0px]"} absolute left-0 bg-primary-900 h-[140px] `} />
                    </Center>
                }
                {icon &&
                    <Box className="absolute top-1 right-1 bg-secondary-50 rounded-full self-end p-1">
                        <IconM className='text-sm text-primary-900' name={icon} />
                    </Box>}
                <Text bold className="text-black mt-3 mb-1 text-xl leading-xl line-clamp-1">
                    {changed && <Text bold className="text-xl leading-xl text-primary-900">{i18n.t('global.new')}</Text>}
                    <Text bold className="text-black mt-3 mb-1 text-xl leading-xl">{task.title}</Text>
                </Text>
                <Text className="font-[400] mb-2 text-lg leading-lg text-secondary-500 line-clamp-1">{i18n.t('showWorkflowScreen.numberOfSteps', { steps: task.steps.length })}</Text>
            </VStack>
        </Button>
    );
}
